import { render, staticRenderFns } from "./ConnectionBanner.vue?vue&type=template&id=4a1205a2&scoped=true&"
import script from "./ConnectionBanner.vue?vue&type=script&lang=js&"
export * from "./ConnectionBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionBanner.vue?vue&type=style&index=0&id=4a1205a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1205a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VChip,VIcon,VSlideXTransition})
